var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('span',[_vm._v(_vm._s(_vm.$t('meta_title.profile')))]),_vm._v(" "),(_vm.user && _vm.user.email)?_c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.user.firstname)+" "+_vm._s(_vm.user.lastname))])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.user.email))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('role.' + _vm.user.role)))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2fe3ba4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Security/profile.vue
// module id = 739
// module chunks = 0